// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"wV","tooltipWrapper":"xV","icon":"yV","tooltip":"zV","content":"AV"};